import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Account } from '../../models/account.model';
import { StepState } from '../../models/step-state.model';

@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss']
})
export class StepComponent implements OnInit {
  public titleKeyName: string;
  @Input() public stepAccount: Account;
  @Output() protected stepModelChanged = new EventEmitter<StepState>();

  constructor(protected translate: TranslateService) {}

  ngOnInit() {}

  protected setTitle(key: string) {
    this.titleKeyName = key;
  }
}
